import {
    SET_AVAILABLE_J,
    SET_MY_J,
    SET_PAST_J,
    SET_CART_J,
    SET_J_MODELS,
    SET_ALL_J_MODELS,
    ADD_DETAILS_J,
    SET_MODEL_REQUESTS
} from './types'

export default function(state={}, action) {
    switch (action.type) {
        /*case ALL_INVENTORY: {
            const {available, my} = action.payload.reduce(({available,my},stone) => {
                if (stone.customerId==null) return {available: available.concat([stone]), my};
                else return {available, my: my.concat([stone])};
            }, {available: [], my: []});
            return {...state, available, my}
        }*/
        case SET_AVAILABLE_J: {
            return {...state, available: action.payload}
        }
        case SET_MY_J: {
            return {...state, my: action.payload}
        }
        case SET_PAST_J: {
            return {...state, past: action.payload}
        }
        case SET_CART_J: {
            return {...state, cart: action.payload}
        }
        case SET_J_MODELS: {
            return {...state, models: action.payload}
        }
        case SET_ALL_J_MODELS: {
            return {...state, allModels: action.payload}
        }
        case ADD_DETAILS_J: {
            if (!action.payload || !action.payload.parcelName) return state;
            return {...state, details: {...state.details, [action.payload.parcelName]: action.payload}}
        }
        case SET_MODEL_REQUESTS: {
            return {...state, toRequest: action.payload}
        }
        default: {
            return state;
        }
    }
}